import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const schema = z.object({
  fields: z.record(z.string().max(100), z.string().max(5000)).refine((o) => Object.keys(o).length <= 60),
  page_url: z.string().max(2000).optional(),
  form_id: z.string().max(200).optional(),
});

/** Called by the site when the embedded HubSpot form submits successfully. */
export const captureLead = createServerFn({ method: "POST" })
  .inputValidator((data) => schema.parse(data))
  .handler(async ({ data }) => {
    const { storeAndNotifyLead } = await import("./leads.server");
    const payload = { ...data.fields, page_url: data.page_url, form_id: data.form_id, source: "site-embed" };
    const result = await storeAndNotifyLead(payload);
    return { ok: true, id: result.id, notified: result.notified };
  });
